module.exports = __webpack_public_path__ + "media/images/smart_phone/ranking_bg-4905f2f6f86116baa44efc70541fd5f6.gif";